export const nodeLabelReplace = (label: string) => label.replace(/\\n/g, '\n');
